import loadable from '@loadable/component';

/* @ts-expect-error type mismatch */
export default loadable(() => import('./AdminMessage'), {
  fallback: (() => null)(),
});
